export const menu = {
  title: "Menú",
  description: "Todas las páginas, tu cuenta y la información legal.",
  signInUp: "Inicia sesión o crea una cuenta",
  explore: "Explorar",
  myPages: "Mis páginas",
  myOverview: "Mi resumen",
  myAds: "Mis anuncios",
  myItems: "Mis artículos",
  new: "Nuevo",
  myDeals: "Mis compras y ventas",
  myBids: "Mis pujas",
  saved: "Anuncios guardados",
  watchlist: "Alertas",
  stats: "Estadísticas",
  account: "Cuenta",
  myProfile: "Mi perfil",
  myAddresses: "Mis direcciones",
  myAccount: "Mi cuenta",
  myCases: "Mis casos",
  about: "Sobre Sellavo",
  languageCountry: "Idioma y país",
  appearance: "Apariencia",
  themeAuto: "Según el sol",
  themeLight: "Claro",
  themeDark: "Oscuro",
  legal: "Legal y cookies",
  admin: "Admin",
  administration: "Administración",
  signOut: "Cerrar sesión",
};
